// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1otGQ","unreadBadge":"styles_unreadBadge__1vF0O","modalContent":"styles_modalContent__dj5lH","modal":"styles_modal__6rLdY"};